import { colors } from 'Constants/Colors';

export const drawerBottom = {
  height: '10%',
  borderRadius: '0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const drawerBottomButton = {
  width: '80%',
  height: '50%',
  background: colors.GREEN,
};

export default { drawerBottom, drawerBottomButton };
